var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.65,
    fillRule: "evenodd",
    d: "M7.304 5.964h1.339V4.625h-1.34v1.34zm0 5.357h1.339V6.768h-1.34v4.553zm.67-10.178c-1.825 0-3.54.71-4.83 2S1.142 6.15 1.142 7.973a6.837 6.837 0 0 0 6.83 6.83h.001c1.824 0 3.54-.71 4.83-2a6.789 6.789 0 0 0 2-4.83 6.838 6.838 0 0 0-6.83-6.83zm3.92 10.75a5.508 5.508 0 0 1-3.92 1.623A5.55 5.55 0 0 1 2.43 7.973a5.51 5.51 0 0 1 1.623-3.92 5.514 5.514 0 0 1 3.92-1.623 5.55 5.55 0 0 1 5.544 5.543 5.507 5.507 0 0 1-1.624 3.92z"
  })));
};
export default SvgInfo;